import { render, staticRenderFns } from "./range-slider.vue?vue&type=template&id=00a8c1d0&"
import script from "./range-slider.vue?vue&type=script&lang=js&"
export * from "./range-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports